import { render, staticRenderFns } from "./AddQuestionDialog.vue?vue&type=template&id=faede41a&scoped=true&"
import script from "./AddQuestionDialog.vue?vue&type=script&lang=js&"
export * from "./AddQuestionDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestionDialog.vue?vue&type=style&index=0&id=faede41a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faede41a",
  null
  
)

export default component.exports